import { combineReducers } from 'redux';

import categories from '@/shared/components/photo_gallery/reducers/categories';
import gallery from '@/shared/components/photo_gallery/reducers/gallery';
import modal from '@/shared/components/photo_gallery/reducers/modal';

// 複数ファイルに分けた reducer をまとめる
export default combineReducers({
    categories,
    gallery,
    modal,
});
